import React, { useState, useEffect,useCallback } from 'react';
import Sidebar from './sidebar/Sidebar';
import Header from './header/Header';
import FetchUserDetails from '../components/UserDetails/FetchUserDetails';
import TreeTableSample from '../components/TreeTableSample';
import AddDocumentModal from './modals/AddDocumentModal';
import CreateBlankModal from './modals/CreateBlankModal';
import ProfileModal from './profile/ProfileModal';
import { searchContracts } from '../utils/searchUtils';
import './CLMHome.css';

const CLMHome = () => {
  // State for modals
  const [isAddDocumentOpen, setIsAddDocumentOpen] = useState(false);
  const [isCreateBlankOpen, setIsCreateBlankOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  const [isGetUserDetailsFunctionExecuted, setIsGetUserDetailsFunctionExecuted] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
  const savedState = sessionStorage.getItem('isSidebarCollapsed');
  return savedState ? JSON.parse(savedState) : false;
});
  
  // State for contracts and search
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredContracts, setFilteredContracts] = useState([]);

  
  

  
  useEffect(() => {
  const getUserDetails = async () => {
    try {
      if (
        sessionStorage.getItem('user_name') &&
        sessionStorage.getItem('user_emailId') &&
        sessionStorage.getItem('user_role')&&
        sessionStorage.getItem('user_id')&&
        sessionStorage.getItem('role_id')
      ) {
        console.log('User details already exist in sessionStorage.');
        setIsGetUserDetailsFunctionExecuted(true);
        return;
      }

      const userFetched = await FetchUserDetails();
      if (userFetched) {
        console.log('User details fetched successfully.');
      } else {
        console.error('Failed to fetch user details.');
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    } finally {
      setIsGetUserDetailsFunctionExecuted(true);
    }
  };

  getUserDetails();
}, []);
  useEffect(() => {
    sessionStorage.setItem('isSidebarCollapsed', JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);


 

  // Handle filter click
  const handleFilterClick = () => {
    // Implement filter functionality
    console.log('Filter clicked');
  };

  // Handle profile click
  const handleProfileClick = () => {
    setIsProfileOpen(true);
  };

  // Handle add new document
  const handleAddNewDocument = () => {
    setIsAddDocumentOpen(true);
  };

  // Handle create blank
  const handleCreateBlank = () => {
    setIsAddDocumentOpen(false);
    setIsCreateBlankOpen(true);
  };

  // Handle select template
  const handleSelectTemplate = () => {
    setIsAddDocumentOpen(false);
    // Implement template selection
    console.log('Template selected');
  };

  // Handle save document
  const handleSaveDocument = (formData) => {
    console.log('Document saved:', formData);
    setIsCreateBlankOpen(false);
  };

  // Handle continue
  const handleContinue = (formData) => {
    console.log('Continue with:', formData);
    setIsCreateBlankOpen(false);
  };
  if (!isGetUserDetailsFunctionExecuted) {
        return <div>Loading...</div>;
      }
  return (
    <div className="clm-container">
      {/* Left Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="main-content">
        {/* Header */}
        
        {/* Contracts Table */}
        <TreeTableSample />
      </div>

      {/* Modals */}
      <AddDocumentModal
        isOpen={isAddDocumentOpen}
        onClose={() => setIsAddDocumentOpen(false)}
        onCreateBlank={handleCreateBlank}
        onSelectTemplate={handleSelectTemplate}
      />

      <CreateBlankModal
        isOpen={isCreateBlankOpen}
        onClose={() => setIsCreateBlankOpen(false)}
        onSave={handleSaveDocument}
        onContinue={handleContinue}
      />

      <ProfileModal
        isOpen={isProfileOpen}
        onClose={() => setIsProfileOpen(false)}
      />
      
    </div>
  );
  
};

export default CLMHome;
